import { PlatformType } from '@okletsplay/core/src/modules/game/enums';
import { useCreateBlocktrisTournamentForm } from 'modules/tournaments/hooks/use-create-blocktris-tournament-form';
import { useCreateDdTournamentForm } from 'modules/tournaments/hooks/use-create-dd-tournament-form';
import { useCreateLichessTournamentForm } from 'modules/tournaments/hooks/use-create-lichess-tournament-form';
import { useCreateLolTournamentForm } from 'modules/tournaments/hooks/use-create-lol-tournament-form';
import { useMemo } from 'react';
import { GameEntity } from '@okletsplay/core';
import { UseFormReturn } from 'react-hook-form';
import { useCreatePapergamesTournamentForm } from './use-create-papergames-tournament-form';
import { useCreateEvIoTournamentForm } from './use-create-ev-io-tournament-form';

export const useTournamentForm = (game: GameEntity) => {
  const { form: lolFrom } = useCreateLolTournamentForm(game);
  const { form: lichessForm } = useCreateLichessTournamentForm(game);
  const { form: blocktrisForm } = useCreateBlocktrisTournamentForm(game);
  const { form: deliveryDashForm } = useCreateDdTournamentForm(game);
  const { form: evIoTournamentForm } = useCreateEvIoTournamentForm(game);
  const { form: papergamesTournamentForm } = useCreatePapergamesTournamentForm(game);

  const createTournamentForm = useMemo(() => {
    switch (game.platformType) {
      case PlatformType.Olp:
        return deliveryDashForm;
      case PlatformType.Colyseus:
      case PlatformType.BubbleUpEndless:
        return blocktrisForm;
      case PlatformType.Lichess:
        return lichessForm;
      case PlatformType.LeagueOfLegends:
        return lolFrom;
      case PlatformType.EvIo:
        return evIoTournamentForm;
      case PlatformType.Papergames:
        return papergamesTournamentForm;
      default:
        return deliveryDashForm;
    }
  }, [
    game.platformType,
    blocktrisForm,
    deliveryDashForm,
    evIoTournamentForm,
    papergamesTournamentForm,
    lichessForm,
    lolFrom,
  ]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return createTournamentForm as UseFormReturn<any>;
};
